<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <EditInspIndexForm :propsInspIndexNo="inspIndexNo" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EditInspIndexForm from '@/components/organisms/terminal/form/EditInspIndexForm'

export default {
  name: 'EditInspIndexPage',

  components: {
    EditInspIndexForm,
  },

  data() {
    return {
      inspIndexNo: '',
    }
  },

  created() {
    const query = this.$route.query
    if (query.inspIndexNo) {
      this.inspIndexNo = query.inspIndexNo
    }
  },
}
</script>
